import React, { useContext, useState } from 'react'

import CopyToClipBoard from 'react-copy-to-clipboard'
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
} from 'react-share'
import { Grid, Header, Button, Popup, Icon, Label } from 'semantic-ui-react'

import { IProject } from '../../../api/Data'
import { UserContext } from '../../../contexts/UserContext'

import ExternalLink from '../../../components/common/ExternalLink'

const CollaborateTabContestLinks = ({ project }: IProps) => {
  const { userProfile } = useContext(UserContext)

  // States
  const [copied, setCopied] = useState(false)

  const { title, description, contestUrl } = project
  const { teamName } = userProfile!
  
  const socialMediaTitle = `Vloggi is a crowd sourcing video platform. You have been invited to contribute video clips to the Vloggi project "${title}" posted by ${teamName} `
  const socialMediaDescription = `Upload your video clips here`

  if (!project) return null

  return (
    <div style={{ textAlign: 'center' }}>
      <Header as="h2" style={{ fontWeight: 'bold' }}>
        By sharing this link
      </Header>
      
      <Grid columns={1} verticalAlign="middle" stackable>
        <Grid.Column>
          <Header as="h4">
            <Header.Subheader>
              Use this unique link on social media, via email marketing or directly on a web page to take contrubutors directly to your project landing page. 
              <Popup
                hoverable
                content={
                  <p>
                    Post link on Facebook, in the bio section of Instagram post or include it into you EDM to get your target audience to upload their videos. (
                    <ExternalLink url="https://vloggi.helpdocs.io/article/t29pnqjn3c-where-to-share-your-video-project">
                      read more
                    </ExternalLink>
                    )
                  </p>
                }
                trigger={<Icon name="info circle" style={{ marginLeft: '0.5rem' }} />}
              />
            </Header.Subheader>
          </Header>
        </Grid.Column>

        <Grid.Column>
          <CopyToClipBoard
            text={contestUrl}
            options={{ format: 'text/plain' }}
            onCopy={() => {
              setCopied(true)
            }}
          >
            <Button as="div" labelPosition="left">
              <Label as="a" basic>
                {contestUrl.split('//')[1]}
              </Label>
              <Button compact icon primary>
                {copied ? 'Copied' : 'Copy link'}
              </Button>
            </Button>
          </CopyToClipBoard>
        </Grid.Column>

        <Grid.Column>
          <Grid textAlign="center" padded stackable>
            <Grid.Column width={3}>
              <EmailShareButton url={contestUrl} subject={socialMediaTitle} body={description}>
                <EmailIcon size={44} round />
              </EmailShareButton>
            </Grid.Column>
            <Grid.Column width={3}>
              <FacebookShareButton url={contestUrl} quote={`${socialMediaTitle} \n ${socialMediaDescription}:`}>
                <FacebookIcon size={44} round />
              </FacebookShareButton>
            </Grid.Column>
            <Grid.Column width={3}>
              <WhatsappShareButton url={contestUrl} title={`${socialMediaTitle} \n ${socialMediaDescription}: \n`}>
                <WhatsappIcon size={44} round />
              </WhatsappShareButton>
            </Grid.Column>
            <Grid.Column width={3}>
              <LinkedinShareButton
                url={contestUrl}
                title={socialMediaTitle}
                summary={socialMediaDescription}
                source="www.vloggi.com"
              >
                <LinkedinIcon size={44} round />
              </LinkedinShareButton>
            </Grid.Column>
          </Grid>
        </Grid.Column>

        <Grid.Column>
          <ExternalLink url="https://vloggi.com/docs/how-contest-voting-works-in-vloggi/">Read more</ExternalLink>
        </Grid.Column>
      </Grid>
    </div>
  )
}

interface IProps {
  project: IProject
}

export default CollaborateTabContestLinks
